<div class="row">
	<div class="col-lg-10">
		<h1>Audits Logs</h1>
		<br>
	</div>
</div>


<div class="dataTables_wrapper" margin>
	<table class="table" datatable="ng" [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"
		class="table table-bordered table-striped" style="width: 100%;">
		<thead class="thead-default">
			<tr>
				<th>Application Name</th>
				<th>Updated By</th>
				<th>Action</th>
				<th>Changes</th>
				<th>Time</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let log of auditLogs">
				<td>{{log.applicationName}}</td>
				<td>{{log.userEmailId}}</td>
				<td>{{log.action}}</td>
				<td>
					<span *ngIf="log.action == 'UPDATED'"><a class="failure-link" role="button"
							(click)="open(content,log)">View Details</a></span>
				</td>
				<td>{{log.time}}</td>
			</tr>
		</tbody>
	</table>
</div>


<ng-template class="modal-dialog" #content let-c="close" let-d="dismiss">

	<div class="modal-header">
		<h4 class="modal-title">Update Details For {{oldValue.applicationName}}</h4>
		<button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>
	<div class="modal-body">
		<table style="table-layout: fixed; text-align: left;width:100%" border="1" class="table"
			class="row-border hover detailsTable">
			<thead class="thead-default">
				<tr>
					<th style="width: 25%;"></th>
					<th>Old Value</th>
					<th>New Value</th>
				</tr>
			</thead>
			<tbody>

				<tr>
					<td><strong>API key</strong></td>
					<td style="word-wrap: break-word;">{{oldValue.apiKey}}</td>
					<td style="word-wrap: break-word;">{{newValue.apiKey}}</td>
				</tr>

				<tr>
					<td><strong>Success Url</strong></td>
					<td style="word-wrap: break-word;">{{oldValue.successUrl}}</td>
					<td style="word-wrap: break-word;">{{newValue.successUrl}}</td>
				</tr>

				<tr>
					<td><strong>Failure Url</strong></td>
					<td style="word-wrap: break-word;">{{oldValue.failureUrl}}</td>
					<td style="word-wrap: break-word;">{{newValue.failureUrl}}</td>
				</tr>

				<tr>
					<td><strong>Cyberscore Threshold</strong></td>
					<td>{{oldValue.cyberScoreThreshold}}</td>
					<td>{{newValue.cyberScoreThreshold}}</td>
				</tr>
				<tr>
					<td><strong>Max failure retries</strong></td>
					<td>{{oldValue.maxFailedRetriesAttempts}}</td>
					<td>{{newValue.maxFailedRetriesAttempts}}</td>
				</tr>
				<tr>
					<td><strong>Period</strong></td>
					<td>{{oldValue.retriesFailedPeriod}}</td>
					<td>{{newValue.retriesFailedPeriod}}</td>
				</tr>
			</tbody>
		</table>
		<h6 class="mt-3">Application created by: {{oldValue.createdBy}}</h6>
		<h6>Time of creation: {{date}} &nbsp;Time: {{time}}</h6>
	</div>
	<div class="modal-footer">
		<button type="button" class="btn btn-outline-dark cls" (click)="c('Close click')">Close</button>
	</div>
</ng-template>